import { environment } from '../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').service('ProviderService', ProviderService);

  ProviderService.$inject = [
    'RestResource',
    'CONFIGURATIONS',
    '$translate',
    '$filter',
    'UtilService',
    'SessionService',
    'UploadService',
    'WindowModalService',
    'ProviderModalService',
  ];

  function ProviderService(
    RestResource,
    config,
    $translate,
    $filter,
    UtilService,
    SessionService,
    UploadService,
    WindowModalService,
    ProviderModalService
  ) {
    var utils = new UtilService(this);

    $translate = $filter('translate');

    var apiUrl = environment.apiEndpoint + 'providers';

    var service = {
      getFilterCriteria: getFilterCriteria,
      getProviders: getProviders,
      getProvider: getProvider,
      saveProvider: saveProvider,
      openLogo: openLogo,
      updateLogo: updateLogo,
      deleteLogo: deleteLogo,
      deleteProvider: deleteProvider,
      changeProviderStatus: changeProviderStatus,
      // changeProviderDefault: changeProviderDefault,
      // changeProviderDefaultNoMsg: changeProviderDefaultNoMsg,
      updateProviders: updateProviders,
      openProviderInfoModal: openProviderInfoModal,

      saveAssociatedProduct: saveAssociatedProduct,
      changeAssociatedProductStatus: changeAssociatedProductStatus,
      deleteAssociatedProduct: deleteAssociatedProduct,

      saveAssociatedProvider: saveAssociatedProvider,
      changeAssociatedProviderStatus: changeAssociatedProviderStatus,
      deleteAssociatedProvider: deleteAssociatedProvider,
      openProviderFastCreate: openProviderFastCreate,
      setAssociatedProviders: setAssociatedProviders,

      saveAssociatedBank: saveAssociatedBank,
      deleteAssociatedBank: deleteAssociatedBank,
    };

    return service;

    ////////////////

    function getFilterCriteria() {
      var filterCriteria = {
        page: 1,
        sortDir: 'asc',
        sortedBy: 'name',
      };

      return filterCriteria;
    }

    function openProviderFastCreate(item, successCallback) {
      ProviderModalService.openProviderFastCreateModal(item, successCallback);
    }

    function getProviders(filterCriteria) {
      if (!filterCriteria) {
        filterCriteria = getFilterCriteria();
      }

      filterCriteria.company_id = SessionService.getSelectedAccountCompany().id;

      return RestResource.request(
        'get',
        apiUrl,
        filterCriteria,
        function (response) {
          response = response.data;

          if (response.meta) {
            return {
              items: utils.cleanItemsCache(response.data, 'logo'),
              meta: utils.getItemsMetaData(response, filterCriteria),
            };
          } else {
            return {
              items: response,
            };
          }
        },
        {}
      );
    }

    function getProvider(id) {
      return RestResource.request(
        'get',
        apiUrl + '/' + id,
        {},
        function (response) {
          response.data.logoUrl = utils.cleanItemCache(response.data, 'logo');
          return response.data;
        },
        function () {
          return false;
        }
      );
    }

    function saveProvider(item, cropedImage) {
      var itemAddedMsg = $translate('NEW_ADDED_PROVIDER');
      var itemModifiedMsg = $translate('MODIFIED_PROVIDER');

      var method = item.id ? 'PUT' : 'POST';
      var url = item.id ? apiUrl + '/' + item.id : apiUrl;

      item.company_id = SessionService.getSelectedAccountCompany().id;

      return UploadService.uploadFile(
        method,
        url,
        'provider',
        item,
        cropedImage,
        function () {},
        function (response) {
          var msg = item.id ? itemModifiedMsg : itemAddedMsg;
          utils._successMsg(msg);

          return response;
        },
        function () {}
      );
    }

    function openLogo(item, saveLogoCallBack) {
      utils.openLogo(item, saveLogoCallBack, 220, 220);
    }

    // Update logo after crop
    function updateLogo(item, cropedImage) {
      var url = apiUrl + '/' + item.id + '?lang=' + config.DEFAULT_CONTENT_LANGUAGE;

      utils.updateLogo(url, 'provider', item, cropedImage);
    }

    function deleteLogo(item, successCallback) {
      let url = apiUrl + '/' + item.id;

      return RestResource.request(
        'put',
        url,
        item,
        function (response) {
          utils._successMsg('PHOTO_DELETED');

          if (successCallback) {
            successCallback(response);
          }
        },
        function () {
          utils._errorMsg('ERROR_UPLOADING');
        }
      );
    }

    function deleteProvider(item, successCallback) {
      let url = apiUrl + '/' + item.id;

      return RestResource.request(
        'delete',
        url + '?check_if_used=true',
        {},
        function () {
          let params = {
            title: 'DELETE_PROVIDER',
            itemName: item.name,
            body: 'DELETING_PROVIDER_WARNING',
            reason: 'DELETE_ITEM_REASON',
            confirmButtonLabel: 'DELETE_PROVIDER',
            successMsg: 'DELETED_PROVIDER',
          };

          utils.deleteItem(url, successCallback, params);
        },
        function (response) {
          utils.openModalError(response.data.error);
        }
      );
    }

    function changeProviderStatus(item) {
      let url = apiUrl + '/' + item.id + '?set_status=true';

      let newStatus = item.status === config.ACTIVE ? config.INACTIVE : config.ACTIVE;

      let params = {
        check_if_used: true,
        status: newStatus,
      };

      return RestResource.request(
        'put',
        url,
        params,
        function () {
          utils.changeItemStatus(url, item);
        },
        function (response) {
          utils.openModalError(response.data.error);
        }
      );
    }

    /*function changeProviderDefault(item, getItemsCallback) {
      var url = apiUrl + '/' + item.id;

      item.is_default = true;

      var params = {
        provider: {
          is_default: true,
        },
        set_default: true,
      };

      function success() {
        var msg = $translate('DEFAULT_PROVIDER_CHANGED');
        utils._successMsg(msg);

        return getItemsCallback();
      }
      function failure() {}

      return RestResource.request('put', url, params, success, failure);
    }*/

    /* function changeProviderDefaultNoMsg(item, getItemsCallback) {
      var url = apiUrl + '/' + item.id;

      item.is_default = true;

      var params = {
        provider: {
          is_default: true,
        },
        set_default: true,
      };

      function success() {
        return getItemsCallback();
      }
      function failure() {}

      return RestResource.request('put', url, params, success, failure);
    } */

    function updateProviders(action, items, successCallback) {
      var params = {
        body: 'DELETING_PROVIDERS_WARNING',
      };

      utils.updateItems(apiUrl, action, items, successCallback, params);
    }

    function openProviderInfoModal(item) {
      var templateUrl = './app/ajs/providers/modals/provider-info-modal.html';

      var additionalParams = {
        dateDisplay: config.DATE_DISPLAY,
      };

      var modalParams = {
        title: 'PROVIDER_DETAILS',
        item: item,
        additionalParams: additionalParams,
      };

      //   var confirmCallback = function (selectedItem) {
      //return getItemsCallback(selectedItem);
      //   };

      WindowModalService.open(templateUrl, modalParams, {});
    }

    function saveAssociatedProduct(associatedProduct, providerId) {
      var itemAddedMsg = $translate('ASSOCIATED_PRODUCT_ADDED');
      var itemModifiedMsg = $translate('ASSOCIATED_PRODUCT_MODIFIED');

      var url = apiUrl + '/' + providerId + '/associated_products';
      var method;

      if (!associatedProduct.id) {
        // create
        method = 'post';
      } else {
        method = 'put';
        url = url + '/' + associatedProduct.id;
      }

      return RestResource.request(
        method,
        url,
        { associated_product: associatedProduct },
        function (response) {
          var msg = associatedProduct.id ? itemModifiedMsg : itemAddedMsg;
          utils._successMsg(msg);

          associatedProduct.id = response.data.id;

          utils.itemListChanged(associatedProduct.id);

          return response.data; // true
        },
        function (response) {
          return response.data;
        }
      );
    }

    function changeAssociatedProductStatus(associatedProduct, providerId) {
      let url = `${apiUrl}/${providerId}/associated_products/${associatedProduct.id}?set_status=true`;

      let newStatus = !associatedProduct.status;

      let params = {
        check_if_used: true,
        status: newStatus,
      };

      return RestResource.request(
        'put',
        url,
        params,
        function () {
          let params = {
            successMsg: 'ASSOCIATED_PRODUCT_DEACTIVATED',
          };

          utils.changeItemStatus(url, associatedProduct, params);
        },
        function (response) {
          utils.openModalError(response.data.error);
        }
      );
    }

    function deleteAssociatedProduct(associatedProduct, providerId, successCallback) {
      let url = apiUrl + '/' + providerId + '/associated_products/' + associatedProduct.id;

      return RestResource.request(
        'delete',
        url + '?check_if_used=true',
        {},
        function () {
          let params = {
            title: 'SURE_TO_REMOVE_ASSOCIATED_PRODUCT',
            body: 'REMOVING_ASSOCIATED_PRODUCT_WARNING',
            successMsg: 'ASSOCIATED_PRODUCT_REMOVED',
          };

          utils.deleteItem(url, successCallback, params);
        },
        function (response) {
          utils.openModalError(response.data.error);
        }
      );
    }

    function saveAssociatedProvider(associatedProvider, providerId) {
      var itemAddedMsg = $translate('ASSOCIATED_PROVIDER_ADDED');
      var itemModifiedMsg = $translate('ASSOCIATED_PROVIDER_MODIFIED');

      var url = apiUrl + '/' + providerId + '/associated_products';
      var method;

      if (!associatedProvider.id) {
        // create
        method = 'post';
        url = url + '/add_associated_provider';
      } else {
        method = 'put';
        url = url + '/' + associatedProvider.id + '/update_associated_provider';
      }

      return RestResource.request(
        method,
        url,
        { associated_product: associatedProvider },
        function (response) {
          var msg = associatedProvider.id ? itemModifiedMsg : itemAddedMsg;
          utils._successMsg(msg);

          utils.itemListChanged(response.data.id);

          return response.data;
        },
        function (response) {
          return response.data;
        }
      );
    }

    // TODO: willy - consider using the same approach as above
    function changeAssociatedProviderStatus(associatedProvider, providerId) {
      var url = `${apiUrl}/${providerId}/associated_products/${associatedProvider.id}/update_associated_provider`;

      var params = {
        successMsg: 'ASSOCIATED_PROVIDER_DEACTIVATED',
      };

      utils.changeItemStatus(url, associatedProvider, params);
    }

    function deleteAssociatedProvider(associatedProvider, providerId, successCallback, index) {
      var params = {
        title: 'SURE_TO_REMOVE_ASSOCIATED_PROVIDER',
        body: 'REMOVING_ASSOCIATED_PROVIDER_WARNING',
        successMsg: 'ASSOCIATED_PROVIDER_REMOVED',
      };

      var url = `${apiUrl}/${providerId}/associated_products/${associatedProvider.id}/delete_associated_provider`;

      utils.deleteItem(url, successCallback, params, index);
    }

    function setAssociatedProviders(associatedProviders, status) {
      if (!associatedProviders) {
        return [];
      }

      let providers = [];
      associatedProviders.forEach(function (associatedProvider) {
        // Only active associations and active providers
        if (
          associatedProvider.provider &&
          associatedProvider.status &&
          associatedProvider.provider.status === 'active'
        ) {
          let item = {
            id: associatedProvider.provider.id,
            name: associatedProvider.provider.name,
            status: associatedProvider.provider.status,
            current_costs: {},
          };

          if (associatedProvider.product) {
            item.current_costs = associatedProvider.product.current_costs;
          }

          providers.push(item);
        }
      });

      // Sort by name asc
      providers.sort((a, b) => (a.name > b.name ? 1 : -1));

      return providers;
    }

    function saveAssociatedBank(associatedBank, providerId) {
      const itemAddedMsg = $translate('ASSOCIATED_BANK_ADDED');
      const itemModifiedMsg = $translate('ASSOCIATED_BANK_MODIFIED');

      let url = apiUrl + '/' + providerId + '/associated_banks';
      let method;

      if (!associatedBank.id) {
        // create
        method = 'post';
      } else {
        method = 'put';
        url = url + '/' + associatedBank.id;
      }

      return RestResource.request(
        method,
        url,
        { associated_bank: associatedBank },
        function (response) {
          const msg = associatedBank.id ? itemModifiedMsg : itemAddedMsg;
          utils._successMsg(msg);

          associatedBank.id = response.data.id;

          utils.itemListChanged(associatedBank.id);

          return response.data; // true
        },
        function (response) {
          return response.data;
        }
      );
    }

    function deleteAssociatedBank(associatedBank, providerId, successCallback) {
      const params = {
        title: 'SURE_TO_REMOVE_ASSOCIATED_BANK',
        successMsg: 'ASSOCIATED_BANK_REMOVED',
      };

      const url = apiUrl + '/' + providerId + '/associated_banks/' + associatedBank.id;
      utils.deleteItem(url, successCallback, params);
    }
  }
})();
